/** =========================================================
 * Customers controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-customers')
    .controller('CustomersController', CustomersController);

  CustomersController.$inject = [
    '$rootScope',
    '$scope',
    '$api',
    '$state',
    '$stateParams',
    '$translate',
    'ngDialog'
  ];

  function CustomersController(
    $rootScope,
    $scope,
    $api,
    $state,
    $stateParams,
    $translate,
    ngDialog
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    function checkEmail(email) {
      $api.post({
        path: '/api/customer_email',
        data: {
          email: email
        }
      }).then(function (response) {
        if (response.data.length > 0) {
          var dialogScope = $scope.$new(true);

          dialogScope.items = response.data;
          dialogScope.email = email;

          ngDialog.openConfirm({
            template: 'app/views/dialogs/customer-already.html',
            scope: dialogScope
          });
        }
      });
    }

    function hasEmailAlready(item, value) {
      var foundEmailsQuantity = item.emails.filter(function (email) {
        return email === value;
      }).length;

      return foundEmailsQuantity !== 0;
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page customers',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'customer',
        getDataParams: {
          order: {
            name: 'asc'
          },
          with: [{
            user: ['id', 'name']
          }],
          count: ['orders']
        },
        filters: angular.copy($stateParams.filters),
        resources: ['user'],
        helpers: {
          checkEmail: checkEmail,
          hasEmailAlready: hasEmailAlready
        },
        fields: [{
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Phone',
          key: 'phone',
          order: true
        }, {
          title: 'Contact person',
          key: 'contact_person',
          order: true
        }, {
          title: 'Responsible user',
          key: 'user_id',
          value: function (item) {
            return item.user ? item.user.name : '';
          },
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-customer.html',
          wide: true,
          item: {
            emails: []
          }
        },
        edit: {
          template: 'app/views/dialogs/item-customer.html',
          wide: true,
          except: [
            'orders_count',
            'user'
          ]
        },
        delete: {},
        linkButtons: [{
          title: 'Orders',
          icon: 'icon-folder-alt',
          class: 'btn-info',
          permission: $rootScope.helpers.hasPermissionTo('order view'),
          action: function (item) {
            try {
              $state.go('app.page-orders', {
                filters: [{
                  name: $translate.instant('Customer') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['customer_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.orders_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
